import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule } from '@spartacus/core';
import { GenProductNotesComponent } from './product-notes.component';
import { SafeModule } from 'src/app/generac/shared/pipes/safe/safe.module';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    SafeModule,
  ],
  declarations: [GenProductNotesComponent],
  exports: [GenProductNotesComponent],
})
export class GenProductNotesModule {}
